import { gql } from "@apollo/client";export default gql`mutation AddCollectionTagMap($objects: [collection_tag_map_insert_input!]!) {
  addCollectionTagMap: insert_collection_tag_map(objects: $objects) {
    affected_rows
  }
}
`;
